import React, {PropsWithChildren} from 'react';
import {DataId, Sx} from 'app/types/common';
import {Box} from '@mui/material';

interface Props extends Sx, DataId {}

export default function HistoryItem({sx, dataId, children}: PropsWithChildren<Props>) {
  return (
    <Box px={1} py={1.5} sx={sx} data-id={dataId}>
      {children}
    </Box>
  );
}
